module.exports = __webpack_public_path__ + "static/media/register.9f6959d8.png";